import React from 'react';
import OLYWebPageComponent from '../components/OLYWebPageComponent';
import moment from 'moment';
import { translate } from 'react-i18next';
import { LinearProgress } from 'material-ui';
import { Typography } from 'material-ui';
import { getLabels } from './cmsLib';
class NewsItem extends OLYWebPageComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            newsid: props.match.params.indexPage,
            newsItem: {
                id: props.match.params.indexPage,
                labels: [
                    { key: 'title', value: '' },
                    { key: 'description', value: '' }
                ],
                image: {
                    url: 'https://i.pinimg.com/736x/b3/5e/96/b35e96088e542c0c4392087fe3eda656.jpg',
                },
                creationDate: new Date(),
                type: 'NewsItemWidget'
            }
        };
        this.pageName = 'NewsItem';
        this.getNewsAsync();
    }

    componentWillUnmount() {
        var element = document.getElementById('cmsImageContainer');
        var cssElem = document.querySelector('.cmsImageForNews');
        cssElem.style.backgroundImage = 'url("/assets/header_bg.png")';

        element.classList.remove('cmsImageForNews');
    }

    modifyBG = (url) => {
        var element = document.getElementById('cmsImageContainer');
        element.classList.add('cmsImageForNews');

        var cssElem = document.querySelector('.cmsImageForNews');
        cssElem.style.backgroundImage = 'url("' + url + '")';
    }

    async getNewsAsync() {
        let rooturl = process.env.REACT_APP_API_URL;
        let newsid = this.state.newsid;
        let lang = this.getUserLang();
        let url = `${rooturl}masterdata/news/${newsid}?language=${lang}`;
        const response = await fetch(url);
        let newsItem;
        try {
            newsItem = await response.json();
            this.modifyBG(newsItem.resource.url);
        } catch (error) {
            newsItem = {};
        }
        this.setState({
            newsItem: newsItem,
            loading: false,
        });
    }

    render() {
        const { t } = this.props;
        const { newsItem } = this.state;
        let title = getLabels(newsItem.labels, 'news.title');
        let description = getLabels(newsItem.labels, 'news.description');

        let creationDate = moment(newsItem.creationDate || new Date()).format('DD MMMM, YYYY');

        return (
            <div className="cmsNewsItemPage">
                <div className="cmsContainer">
                    <div style={{ margin: '5px' }}>
                        {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                    </div>
                    <Typography variant="title" className="title" dangerouslySetInnerHTML={{ __html: title}}></Typography>
                    <Typography variant="subheading" className="creationDate">{creationDate}</Typography>
                    <Typography variant="body2" className="description, newsPaper" dangerouslySetInnerHTML={{ __html: description}}></Typography>
                </div>
            </div>
        );
    }
}

export default translate('translations')(NewsItem);


// WEBPACK FOOTER //
// ./src/cms/NewsItem.js